module.exports = __webpack_public_path__ + "71fce40ee62ddc8b92e0fc56ab6d9e0b.png";